import { createElement, Props as ReactProps } from 'react';
import styled from 'styled-components';
import {
  STRING_COLOR,
} from '../../constants/color';

const TEXT_SIZES = {
  tiny: 12,
  small: 14,
  regular: 16,
  large: 20,
  huge: 24,
  // enormous: ,
};

export type Props = ReactProps<HTMLSpanElement> & {
  size?: 'tiny' | 'small' | 'regular' | 'large' | 'huge';
  color?: string;
  bold?: boolean;
  className?: string;
  singleLine?: boolean;
};

const Self = styled.span<any>`
  display: inline-block;
  font-family: "Noto Sans", "Noto Sans Japanese";
  vertical-align: bottom;
  word-break: break-all;
  word-wrap: break-word;
  color: ${props => props.color || STRING_COLOR};
  font-size: ${props => TEXT_SIZES[props.size] && `${TEXT_SIZES[props.size]}px`};
  font-weight: ${props => props.bold ? 700 : 400};
`;

const SingleLine = styled(Self)<any>`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
`;

const Text = (props: Props) => {
  const Item = props.singleLine ? SingleLine : Self;
  return (
    <Item {...props}>
      {props.children}
    </Item>
  );
};

export default Text;
